import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import BookingModule from "@/store/modules/booking";
import POSConfigModule from "@/store/modules/pos-config";
import { BookingStatus } from "@/types/db/product-slot-state";
import { computed, defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import { addToBasket } from "@/utils/vue-helpers/product-category";
import { cloneDeep } from "lodash";
import { generateHoldToken } from "@/api/seats-io/seats-io";
import { deleteUnconfirmedTickets } from "@/utils/vue-helpers/booking";
import { handleHoldTokenExpiration } from "@/utils/vue-helpers/seats-io";
import { LogLevel, LogService } from "@/services/logging";
import NotificationService from "@/services/notification.service";
import { renderChartInCustomerDisplay } from "@/utils/vue-helpers/customer-display";
export var seatStatus;

(function (seatStatus) {
  seatStatus["free"] = "free";
  /**
   * means that the object is temporarily 'locked' so that only the person that originally held it can confirm the booking through a secret hold token.
   * If no booking arrives within 15 minutes (by default) of holding the objects, seats.io automatically releases the held objects again.
   */

  seatStatus["reservedByTokenand"] = "reservedByTokenand";
  seatStatus["booked"] = "booked";
})(seatStatus || (seatStatus = {}));

export default defineComponent({
  name: "SeatingPlan",
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  setup: function setup(props) {
    console.log("hi from created of seating plan");

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var selectedBookingUUID = computed(function () {
      return BookingModule.selectedBookingUUID;
    }); // Holds IProductCategory.product object, not the PC itself
    // Usefull when creating PSS

    var productSlot = computed(function () {
      return props.product.seatedSubs && props.product.seatedSubs.length ? props.product.seatedSubs[0].product : null;
    });
    var eventKey = computed(function () {
      return props.product.eventKey;
    }); // Holds Timeslot data, useful when creating PSS

    var timeSlot = computed(function () {
      return {
        id: Number(props.product.timeslot_ID),
        startDateTime: props.product.startDateTime,
        endDateTime: props.product.endDateTime
      };
    });
    var seatsio = ref(null);
    var chartId = "chart-".concat(selectedBookingUUID.value);
    var chart = ref(null);
    var isChartPresent = ref(false);
    var isCallsInProgress = ref(false);
    var chartRenderingStart = new Date(); // We want pricingData getter of chartConfig to do some prices filtering
    // - we want this to happen only when the user selects a customer or when the chart is completely rendered
    // - we don't want this filtering to happen when rendering the chart
    // because in a scenario where the user is coming back from membership validation page
    // he will find his charts empty even though he has already selected from it,
    // the selected seats will disappear because we rendered the chart without their prices

    var isChartRendering = ref(false); // Coming from B2C
    // Groups for which we'll add noOrphanSeats validation

    var activateNoOrphanSeatsValidation = computed(function () {
      var noOrphanSeatsValidation = [14773, 19066, 19017, 19377, 18916, 19380, 18636, 19644];
      var groupId = Number(POSConfigModule.groupId);
      return noOrphanSeatsValidation.includes(groupId);
    });
    return {
      t: t,
      seatsio: seatsio,
      chartId: chartId,
      chart: chart,
      isChartRendering: isChartRendering,
      isChartPresent: isChartPresent,
      isCallsInProgress: isCallsInProgress,
      activateNoOrphanSeatsValidation: activateNoOrphanSeatsValidation,
      selectedBookingUUID: selectedBookingUUID,
      productSlot: productSlot,
      addToBasket: addToBasket,
      timeSlot: timeSlot,
      eventKey: eventKey,
      chartRenderingStart: chartRenderingStart
    };
  },
  created: function created() {
    //
    console.log("hi from creted of SeatoingPlan this.props.product");
    console.log(this.$props.product);
    this.eventKey = this.$props.product.eventKey;
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var dt2, period, dialog, closeButton;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("hi from mounted of seating plan"); ///////

              dt2 = new Date();
              period = (dt2.getTime() - _this.chartRenderingStart.getTime()) / 1000;
              console.log("-------- mounting seating component took: ", period);
              LogService.info("Seating plan component mounting took ".concat(period, " seconds")); /////////////////

              dialog = document.querySelector("dialog");
              console.log("dialog");
              console.log(dialog);

              if (!dialog) {
                _context.next = 32;
                break;
              }

              console.log("inside dialog"); //   const showButton = document.querySelector("dialog + button");

              closeButton = document.querySelector("#closePopup"); // "Show the dialog" button opens the dialog modally
              //   if (showButton) {
              //     console.log("inside showButton");
              //     showButton.addEventListener("click", () => {
              //       dialog.showModal();
              //     });
              //   }

              dialog.showModal(); // "Close" button closes the dialog

              if (closeButton) {
                console.log("inside closeButton");
                closeButton.addEventListener("click", function () {
                  // Emitting the even to update showseatingChart ref in Card.vue
                  _this.$emit("closing-modal");

                  dialog.close();
                });
              } // Seating Plan rendering


              _context.prev = 13;
              _context.prev = 14;
              _context.next = 17;
              return _this.loadChartJS();

            case 17:
              console.log("Chart.js loaded successfully"); // Now Chart.js is available for use

              _context.next = 25;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](14);
              console.error("Failed to load Chart.js", _context.t0);
              LogService.info("Error, failed to load Chart.js", _context.t0, LogLevel.Error);
              dialog.close();

            case 25:
              _this.seatsio = window.seatsio;
              _this.isChartRendering = true;
              _this.chartRenderingStart = new Date();

              _this.renderChart();

              _this.isChartRendering = false;

            case 30:
              _context.prev = 30;
              return _context.finish(30);

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[13,, 30, 32], [14, 20]]);
    }))();
  },
  methods: {
    loadChartJS: function loadChartJS() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var script;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Check if the script element already exists
                script = document.getElementById("chartScript");

                if (script) {
                  _context2.next = 11;
                  break;
                }

                // If script element doesn't exist, create it
                script = document.createElement("script");
                script.id = "chartScript";
                script.src = "https://cdn.seatsio.net/chart.js";
                script.async = true;
                document.body.appendChild(script); // Wait for script to load

                _context2.next = 9;
                return new Promise(function (resolve, reject) {
                  script.onload = resolve;
                  script.onerror = reject;
                });

              case 9:
                _context2.next = 13;
                break;

              case 11:
                // If script element already exists, log a message (optional)
                console.log("Chart.js script already loaded");
                LogService.info("Chart.js script already loaded");

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    renderChart: function renderChart() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _POSConfigModule$grou;

        var pricingData, ticketTypes, availableCategories, availableCategoriesWithoutDuplicate, currency, _POSConfigModule$grou2, _POSConfigModule$grou3, _BookingModule$select, holdToken, mainScreenChartConfig, alreadySelectedSeatsOfTheBooking, customerScreenChartData;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("hi from renderChart");
                pricingData = _this2.buildPricingData(_this2.$props.product.seatedSubs);
                console.log("-------- pricingData");
                console.log(pricingData);
                ticketTypes = pricingData.map(function (p) {
                  return p.ticketTypes;
                }).flat();
                console.log("-------- ticketTypes");
                console.log(ticketTypes);
                availableCategories = ticketTypes.map(function (t) {
                  return t.seatsCat;
                }); // Kicking out seat categories (categories in seats io) that don't have corresponding sub-category linked to the sales collection as in parentPC we have subCategories that are linked to the sales collection only

                console.log("availableCategories");
                console.log(availableCategories);
                availableCategoriesWithoutDuplicate = _toConsumableArray(new Set(availableCategories));
                console.log("availableCategoriesWithoutDuplicate");
                console.log(availableCategoriesWithoutDuplicate);
                console.log("POSConfigModule.groupInfo?.seatsPublicKey");
                console.log((_POSConfigModule$grou = POSConfigModule.groupInfo) === null || _POSConfigModule$grou === void 0 ? void 0 : _POSConfigModule$grou.seatsPublicKey);
                currency = _this2.$props.product.currency;
                _context3.prev = 16;

                if (!(BookingModule.getSeatsIoHoldToken && BookingModule.getSeatsIoHoldToken.holdToken)) {
                  _context3.next = 21;
                  break;
                }

                _context3.t0 = BookingModule.getSeatsIoHoldToken.holdToken;
                _context3.next = 24;
                break;

              case 21:
                _context3.next = 23;
                return _this2.generateSeatsIoHoldToken();

              case 23:
                _context3.t0 = _context3.sent;

              case 24:
                holdToken = _context3.t0;
                LogService.info("Seating plan chart going to be created and rendered with attached info", {
                  params: {
                    holdToken: holdToken,
                    pricingData: pricingData,
                    ticketTypes: ticketTypes,
                    availableCategories: availableCategories,
                    workspaceKey: (_POSConfigModule$grou2 = POSConfigModule.groupInfo) === null || _POSConfigModule$grou2 === void 0 ? void 0 : _POSConfigModule$grou2.seatsPublicKey,
                    event: _this2.$props.product.eventKey
                  }
                });
                mainScreenChartConfig = {
                  objectPopover: {
                    showAvailability: false,
                    showCategory: true,
                    showLabel: true,
                    showPricing: true,
                    showUnavailableNotice: true,
                    stylizedLabel: true,
                    confirmSelection: "auto",
                    confirmTicketTypeSelection: true
                  },
                  divId: _this2.chartId,
                  workspaceKey: (_POSConfigModule$grou3 = POSConfigModule.groupInfo) === null || _POSConfigModule$grou3 === void 0 ? void 0 : _POSConfigModule$grou3.seatsPublicKey,
                  event: _this2.$props.product.eventKey,
                  // session: session,
                  session: "manual",
                  holdToken: holdToken,
                  // holdOnSelect: true, // An error will be thrown: Invalid seats.io config: holdOnSelect is not allowed when passing in session
                  holdOnSelectForGAs: true,
                  showSectionContents: "always",
                  pricing: pricingData,
                  priceFormatter: function priceFormatter(price) {
                    return currency + " " + price.toFixed(2);
                  },
                  availableCategories: availableCategoriesWithoutDuplicate,
                  showFullScreenButton: true,
                  showZoomOutButtonOnMobile: true,
                  inputDevice: "auto",
                  // language: this.t.locale,
                  onChartRendered: _this2.onChartRendered,
                  onChartRenderingFailed: _this2.onChartRenderingFailed,
                  onHoldSucceeded: _this2.onHold,
                  onHoldCallsInProgress: _this2.onHoldCallsInProgress,
                  onHoldCallsComplete: _this2.onHoldCallsComplete,
                  onHoldFailed: _this2.onHoldFailed,
                  onReleaseHoldSucceeded: _this2.onRelease,
                  onObjectSelected: _this2.onObjectSelected
                  /*this.showQuasarSpinner*/
                  ,
                  onObjectDeselected: _this2.onObjectDeselected,
                  onObjectClicked: _this2.onObjectClicked,
                  // selectionValidators: this.activateNoOrphanSeatsValidation ?
                  // [{type: 'noOrphanSeats', mode: 'lenient'}] : undefined,
                  onSelectionInvalid: _this2.onSelectionInvalid,
                  onSelectionValid: _this2.onSelectionValid
                };
                console.log("-------- mainScreenChartConfig");
                console.log(mainScreenChartConfig);
                _this2.chart = new _this2.seatsio.SeatingChart(mainScreenChartConfig).render();
                console.log("-------- this.chart");
                console.log(_this2.chart);
                _this2.isChartPresent = true; // Showing the same chart on Customer Display with seats already selected
                // if the booking has seats from more then one even then we need to show seats selected in their correct charts, so we will filter using eventKey as well

                alreadySelectedSeatsOfTheBooking = (_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.pssList.filter(function (ps) {
                  return ps.eventKey && ps.eventKey === _this2.chart.config.event && ps.seat && ps.bookingStatus !== BookingStatus.Abandoned && ps.bookingStatus !== BookingStatus.Canceled;
                }).map(function (ps) {
                  return ps.seat;
                });
                customerScreenChartData = JSON.parse(JSON.stringify(mainScreenChartConfig)); // In order to see already selected seats, and see selected/deselected seats live, CustomerChart will be shown in:
                // 1- Static mode
                // 2- Manual session
                // 3- Same holdToken
                // 4- Same pricing field
                // 5- selectedObjects field

                customerScreenChartData.mode = "static"; //"spotlight";

                customerScreenChartData.selectedObjects = alreadySelectedSeatsOfTheBooking; // No need for pricing in spotlight mode since it is not relevant, says Matti of seatsIO
                // important: if we pass in 'pricing' then we will need to pass ticketTypes in selectedObjects array.
                // customerScreenChartData.pricing = [];

                _context3.next = 39;
                return renderChartInCustomerDisplay(customerScreenChartData);

              case 39:
                _context3.next = 46;
                break;

              case 41:
                _context3.prev = 41;
                _context3.t1 = _context3["catch"](16);
                console.log("failed to render chart with following error");
                console.log(_context3.t1);
                LogService.info("Error, failed to render chart", _context3.t1, LogLevel.Error);

              case 46:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[16, 41]]);
      }))();
    },
    onChartRendered: function onChartRendered(chart) {
      console.log("----- onChartRendered"); // console.log("chart");
      // console.log(chart);

      var dt2 = new Date();
      var period = (dt2.getTime() - this.chartRenderingStart.getTime()) / 1000;
      console.log("-------- rendering the chart took: ", period);
      LogService.info("Seating plan chart rendering took ".concat(period, " seconds"));
    },
    onChartRenderingFailed: function onChartRenderingFailed(chart) {
      // TODO Hamza log and throw an error
      console.log("----- onChartRenderingFailed");
      console.log("chart");
      console.log(chart);
      var dt2 = new Date();
      var period = (dt2.getTime() - this.chartRenderingStart.getTime()) / 1000;
      console.log("-------- rendering the chart failed after: ", period);
      LogService.info("Error, onChartRenderingFailed event triggered after ".concat(period, " seconds"), {
        params: chart
      }, LogLevel.Error);
    },
    onHold: function onHold(objects, ticketTypes) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var heldObject, pssQuantity, heldObjectUsefulData, selectedPC, selectedPrice;
        return regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log("----- onHold");
                console.log("this.productSlot");
                console.log(_this3.productSlot);
                console.log("objects");
                console.log(objects);
                console.log("ticketTypes");
                console.log(ticketTypes);
                LogService.info("Seating Plan onHold triggered with attached data", {
                  params: {
                    objects: objects,
                    ticketTypes: ticketTypes
                  }
                });

                if (!(objects && objects.length && objects[0].objectType === "GeneralAdmissionArea")) {
                  _context6.next = 12;
                  break;
                }

                return _context6.delegateYield( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  var selectionPerTicketType, holdPrices, _loop, i, _ret;

                  return regeneratorRuntime.wrap(function _callee4$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          console.log("------ geenral admission case"); // In case of GA we do the following
                          // We take the last object
                          // and take its objects[i].selectionPerTicketType
                          // which is in this shape: { "152030": 1, "346233": 2}
                          // knowing that properties' names are actually prices IDs
                          // as we said we take this selectionPerTicketType
                          // and loop thru its properties (in this case: "152030" and "346233")
                          // and create X pss so that X is the value of the property

                          selectionPerTicketType = objects[objects.length - 1].selectionPerTicketType;
                          console.log("------- selectionPerTicketType");
                          console.log(selectionPerTicketType);
                          holdPrices = Object.keys(selectionPerTicketType);
                          console.log("------- holdPrices");
                          console.log(holdPrices);
                          _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i) {
                            var _BookingModule$select2;

                            var heldObject, correspondingTicketType, alreadyExistingPSSOfThisPrice, pssQuantity, heldObjectUsefulData, selectedPC, selectedPrice;
                            return regeneratorRuntime.wrap(function _loop$(_context4) {
                              while (1) {
                                switch (_context4.prev = _context4.next) {
                                  case 0:
                                    heldObject = objects[0];
                                    correspondingTicketType = ticketTypes.find(function (t) {
                                      return String(t.priceId) === holdPrices[i];
                                    });
                                    console.log("correspondingTicketType");
                                    console.log(correspondingTicketType);

                                    if (correspondingTicketType) {
                                      _context4.next = 6;
                                      break;
                                    }

                                    return _context4.abrupt("return", "continue");

                                  case 6:
                                    // If a user book this kind of ticket in two steps (meaning opening the chart more than one time) seats io will keep sending us ticket that was previously booking and we already created their PSS
                                    // so we need to deduct them from the quantity of pss we're about to create
                                    alreadyExistingPSSOfThisPrice = ((_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.pssList.filter(function (pss) {
                                      return pss.priceId === correspondingTicketType.priceId && pss.bookingStatus === BookingStatus.Pending;
                                    }).length) || 0;
                                    console.log("alreadyExistingPSSOfThisPrice");
                                    console.log(alreadyExistingPSSOfThisPrice);
                                    pssQuantity = selectionPerTicketType[holdPrices[i]] - alreadyExistingPSSOfThisPrice;
                                    console.log("pssQuantity");
                                    console.log(pssQuantity);
                                    heldObjectUsefulData = {
                                      seatId: heldObject.seatId,
                                      seatType: heldObject.objectType,
                                      seatUuid: heldObject.uuid,
                                      objectType: heldObject.objectType,
                                      companionSeat: heldObject.companionSeat,
                                      isOrphan: heldObject.isOrphan,
                                      priceId: correspondingTicketType.priceId,
                                      priceName: correspondingTicketType.priceName,
                                      categoryId: correspondingTicketType.categoryId,
                                      categoryName: correspondingTicketType.category,
                                      productId: _this3.productSlot.id,
                                      productName: _this3.productSlot.name,
                                      timeSlotId: _this3.timeSlot.id,
                                      startDateTime: _this3.timeSlot.startDateTime,
                                      endDateTime: _this3.timeSlot.endDateTime
                                    };
                                    console.log("---- heldObjectUsefulData");
                                    console.log(heldObjectUsefulData);
                                    selectedPC = _this3.$props.product.seatedSubs.find(function (pc) {
                                      return pc.id === heldObjectUsefulData.categoryId;
                                    });
                                    selectedPrice = selectedPC.prices.find(function (pc) {
                                      return pc.id === heldObjectUsefulData.priceId;
                                    }); // Now we know seats io successfully held a seat, lets proceed from our side
                                    // selecting timeslotId in the booking module for POS logic pss creation

                                    BookingModule.selectTSID(String(heldObjectUsefulData.timeSlotId)); // selecting pcId in the booking module for POS logic pss creation

                                    BookingModule.selectPCID(String(heldObjectUsefulData.categoryId));
                                    _context4.prev = 19;
                                    _context4.next = 22;
                                    return addToBasket({
                                      selectedProduct: selectedPC,
                                      pssQuantity: pssQuantity,
                                      isRetail: false,
                                      price: selectedPrice,
                                      productCategory: selectedPC,
                                      seatId: heldObjectUsefulData.seatId,
                                      eventKey: _this3.eventKey,
                                      seatType: heldObjectUsefulData.seatType
                                    });

                                  case 22:
                                    LogService.info("Seating ticket added to basket");
                                    _context4.next = 29;
                                    break;

                                  case 25:
                                    _context4.prev = 25;
                                    _context4.t0 = _context4["catch"](19);
                                    console.log(_context4.t0);
                                    LogService.info("Error, failed to add seating ticket to basket", _context4.t0, LogLevel.Error);

                                  case 29:
                                  case "end":
                                    return _context4.stop();
                                }
                              }
                            }, _loop, null, [[19, 25]]);
                          });
                          i = 0;

                        case 9:
                          if (!(i < holdPrices.length)) {
                            _context5.next = 17;
                            break;
                          }

                          return _context5.delegateYield(_loop(i), "t0", 11);

                        case 11:
                          _ret = _context5.t0;

                          if (!(_ret === "continue")) {
                            _context5.next = 14;
                            break;
                          }

                          return _context5.abrupt("continue", 14);

                        case 14:
                          i++;
                          _context5.next = 9;
                          break;

                        case 17:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee4);
                })(), "t0", 10);

              case 10:
                _context6.next = 30;
                break;

              case 12:
                console.log("------ seating plan case"); // For seating plans we keep the old logic because there will never be many seats selected with many prices in one popover

                heldObject = objects && objects.length ? objects[0] : null;
                pssQuantity = objects && objects.length ? objects.length : 0;
                heldObjectUsefulData = {
                  seatId: heldObject.seatId,
                  seatType: heldObject.objectType,
                  seatUuid: heldObject.uuid,
                  objectType: heldObject.objectType,
                  companionSeat: heldObject.companionSeat,
                  isOrphan: heldObject.isOrphan,
                  priceId: ticketTypes[0].priceId,
                  priceName: ticketTypes[0].priceName,
                  categoryId: ticketTypes[0].categoryId,
                  categoryName: ticketTypes[0].category,
                  productId: _this3.productSlot.id,
                  productName: _this3.productSlot.name,
                  timeSlotId: _this3.timeSlot.id,
                  startDateTime: _this3.timeSlot.startDateTime,
                  endDateTime: _this3.timeSlot.endDateTime
                };
                selectedPC = _this3.$props.product.seatedSubs.find(function (pc) {
                  return pc.id === heldObjectUsefulData.categoryId;
                });
                selectedPrice = selectedPC.prices.find(function (pc) {
                  return pc.id === heldObjectUsefulData.priceId;
                }); // Now we know seats io successfully held a seat, lets proceed from our side
                // selecting timeslotId in the booking module for POS logic pss creation

                BookingModule.selectTSID(String(heldObjectUsefulData.timeSlotId)); // selecting pcId in the booking module for POS logic pss creation

                BookingModule.selectPCID(String(heldObjectUsefulData.categoryId));
                _context6.prev = 20;
                _context6.next = 23;
                return addToBasket({
                  selectedProduct: selectedPC,
                  pssQuantity: pssQuantity,
                  isRetail: false,
                  price: selectedPrice,
                  productCategory: selectedPC,
                  seatId: heldObjectUsefulData.seatId,
                  eventKey: _this3.eventKey,
                  seatType: heldObjectUsefulData.seatType
                });

              case 23:
                LogService.info("Seating ticket added to basket"); ////////////////
                // No need to do the below since this is now automatically handled by static mode
                // // here we should send the newly selected seats to the customer screen
                // await selectSeatsInCustomerDisplay([heldObjectUsefulData.seatId]);
                ////////////////

                _context6.next = 30;
                break;

              case 26:
                _context6.prev = 26;
                _context6.t1 = _context6["catch"](20);
                console.log(_context6.t1);
                LogService.info("Error, failed to add seating ticket to basket", _context6.t1, LogLevel.Error);

              case 30:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, null, [[20, 26]]);
      }))();
    },
    onHoldCallsInProgress: function onHoldCallsInProgress() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log("----------- hi from onHoldCallsInProgress");
                _this4.isCallsInProgress = true;

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onHoldCallsComplete: function onHoldCallsComplete() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log("----------- hi from onHoldCallsComplete");
                _this5.isCallsInProgress = false;

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee7);
      }))();
    },
    onHoldFailed: function onHoldFailed(args) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // console.log("hi from onHoldFailed");
                // console.log(f);
                LogService.info("Seating Plan onHoldFailed triggered with attached data", {
                  params: {
                    args: args
                  }
                });

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee8);
      }))();
    },
    onRelease: function onRelease(objects, deselectedTicketTypes) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _loop2, i, _loop3, _i;

        return regeneratorRuntime.wrap(function _callee9$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                console.log("----- onRelease");
                LogService.info("Seating Plan / General Admission onRelease triggered with attached data", {
                  params: {
                    objects: objects,
                    deselectedTicketTypes: deselectedTicketTypes
                  }
                });
                console.log("objects");
                console.log(objects);
                console.log("deselectedTicketTypes");
                console.log(deselectedTicketTypes);

                if (!(objects && objects.length && objects[0].objectType === "GeneralAdmissionArea")) {
                  _context12.next = 17;
                  break;
                }

                console.log("------ geenral admission case"); // In deselectedTicketTypes array there are all the details of pss that need to be deleted, lets use it instead of objects array

                _loop2 = /*#__PURE__*/regeneratorRuntime.mark(function _loop2(i) {
                  var _BookingModule$select3;

                  var deselectedTicketType, deselectedSeatId, deselectedPssPriceId, deselectedPssCategoryId, deselectedSeatEventKey, pssList, deselectedPSS, addonsToRemove, releaseSeats;
                  return regeneratorRuntime.wrap(function _loop2$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          deselectedTicketType = deselectedTicketTypes[i];
                          deselectedSeatId = objects[0].id;
                          deselectedPssPriceId = deselectedTicketType.priceId;
                          deselectedPssCategoryId = deselectedTicketType.categoryId; // For now we allow user to remove only unconfirmed pss by deselecting seats on the chart

                          deselectedSeatEventKey = _this6.eventKey; // Now lets get the pss that is linked to the deselected seat

                          pssList = (_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.pssList;
                          deselectedPSS = pssList === null || pssList === void 0 ? void 0 : pssList.find(function (ps) {
                            return ps.seat && ps.seat === deselectedSeatId && ps.priceId === deselectedPssPriceId && ps.categoryId === deselectedPssCategoryId && ps.eventKey === deselectedSeatEventKey;
                          });
                          console.log("deselectedPSS");
                          console.log(deselectedPSS);

                          if (!deselectedPSS) {
                            _context10.next = 22;
                            break;
                          }

                          addonsToRemove = pssList === null || pssList === void 0 ? void 0 : pssList.filter(function (ps) {
                            return ps.mainTicketUUID && ps.mainTicketUUID === deselectedPSS.uuid;
                          }); // lets delete the deselected pss from pssList of the booking

                          _context10.prev = 11;
                          releaseSeats = false; // Because seats are already released by user action on the chart

                          _context10.next = 15;
                          return deleteUnconfirmedTickets([String(deselectedPSS.uuid)].concat(_toConsumableArray((addonsToRemove === null || addonsToRemove === void 0 ? void 0 : addonsToRemove.map(function (ps) {
                            return String(ps.uuid);
                          })) || [])), releaseSeats);

                        case 15:
                          LogService.info("Seating ticket removed from basket, pss: ".concat(deselectedPSS.uuid)); ////////////////
                          // No need to do the below since this is now automatically handled by static mode
                          // // here we should send the deselected seats to the customer screen
                          // await deselectSeatsInCustomerDisplay([deselectedSeatId]);
                          ////////////////

                          _context10.next = 22;
                          break;

                        case 18:
                          _context10.prev = 18;
                          _context10.t0 = _context10["catch"](11);
                          console.log(_context10.t0);
                          LogService.info("Error, failed to remove seating ticket from basket, pss: ".concat(deselectedPSS.uuid), _context10.t0, LogLevel.Error);

                        case 22:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _loop2, null, [[11, 18]]);
                });
                i = 0;

              case 10:
                if (!(i < deselectedTicketTypes.length)) {
                  _context12.next = 15;
                  break;
                }

                return _context12.delegateYield(_loop2(i), "t0", 12);

              case 12:
                i++;
                _context12.next = 10;
                break;

              case 15:
                _context12.next = 25;
                break;

              case 17:
                console.log("------ seating plan case"); // For seating plans we keep the old logic because there will never be many seats deselected with many prices in one popover

                _loop3 = /*#__PURE__*/regeneratorRuntime.mark(function _loop3(_i) {
                  var _BookingModule$select4;

                  var object, deselectedTicketType, deselectedSeatId, deselectedPssPriceId, deselectedPssCategoryId, deselectedSeatEventKey, pssList, deselectedPSS, addonsToRemove, releaseSeats;
                  return regeneratorRuntime.wrap(function _loop3$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          object = objects[_i];
                          deselectedTicketType = deselectedTicketTypes[0];
                          LogService.info("Seating plan onRelease triggered with attached parameters", {
                            params: {
                              objects: object,
                              deselectedTicketType: deselectedTicketType
                            }
                          });
                          deselectedSeatId = object.id;
                          deselectedPssPriceId = deselectedTicketType.priceId;
                          deselectedPssCategoryId = deselectedTicketType.categoryId; // For now we allow user to remove only unconfirmed pss by deselecting seats on the chart

                          deselectedSeatEventKey = _this6.eventKey; // Now lets get the pss that is linked to the deselected seat

                          pssList = (_BookingModule$select4 = BookingModule.selectedBooking) === null || _BookingModule$select4 === void 0 ? void 0 : _BookingModule$select4.pssList;
                          deselectedPSS = pssList === null || pssList === void 0 ? void 0 : pssList.find(function (ps) {
                            return ps.seat && ps.seat === deselectedSeatId && ps.priceId === deselectedPssPriceId && ps.categoryId === deselectedPssCategoryId && ps.eventKey === deselectedSeatEventKey;
                          });
                          console.log("deselectedPSS");
                          console.log(deselectedPSS);

                          if (!deselectedPSS) {
                            _context11.next = 24;
                            break;
                          }

                          addonsToRemove = pssList === null || pssList === void 0 ? void 0 : pssList.filter(function (ps) {
                            return ps.mainTicketUUID && ps.mainTicketUUID === deselectedPSS.uuid;
                          }); // lets delete the deselected pss from pssList of the booking

                          _context11.prev = 13;
                          releaseSeats = false; // Because seats are already released by user action on the chart

                          _context11.next = 17;
                          return deleteUnconfirmedTickets([String(deselectedPSS.uuid)].concat(_toConsumableArray((addonsToRemove === null || addonsToRemove === void 0 ? void 0 : addonsToRemove.map(function (ps) {
                            return String(ps.uuid);
                          })) || [])), releaseSeats);

                        case 17:
                          LogService.info("Seating ticket removed from basket, pss: ".concat(deselectedPSS.uuid)); ////////////////
                          // No need to do the below since this is now automatically handled by static mode
                          // // here we should send the deselected seats to the customer screen
                          // await deselectSeatsInCustomerDisplay([deselectedSeatId]);
                          ////////////////

                          _context11.next = 24;
                          break;

                        case 20:
                          _context11.prev = 20;
                          _context11.t0 = _context11["catch"](13);
                          console.log(_context11.t0);
                          LogService.info("Error, failed to remove seating ticket from basket, pss: ".concat(deselectedPSS.uuid), _context11.t0, LogLevel.Error);

                        case 24:
                        case "end":
                          return _context11.stop();
                      }
                    }
                  }, _loop3, null, [[13, 20]]);
                });
                _i = 0;

              case 20:
                if (!(_i < objects.length)) {
                  _context12.next = 25;
                  break;
                }

                return _context12.delegateYield(_loop3(_i), "t1", 22);

              case 22:
                _i++;
                _context12.next = 20;
                break;

              case 25:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee9);
      }))();
    },
    onObjectSelected: function onObjectSelected(object, selectedTicketType) {
      console.log("----- onObjectSelected"); // console.log("object");
      // console.log(object);
      // console.log("selectedTicketType");
      // console.log(selectedTicketType);

      LogService.info("Seating Plan onObjectSelected triggered with attached data", {
        params: {
          object: object,
          selectedTicketType: selectedTicketType
        }
      });
    },
    onObjectDeselected: function onObjectDeselected(object, deselectedTicketType) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                // IMPORTANT: This event is triggered by two
                // 1- User deselecting in the chart
                // 2- User removing tickets from the basket
                // In case of GA we should be extra careful because we may endup deselecting GA tickets that were not really removed by the user on the basket
                console.log("----- onObjectDeselected");
                console.log("object");
                console.log(object);
                console.log("deselectedTicketType");
                console.log(deselectedTicketType);
                LogService.info("Seating plan onObjectDeselected triggered with attached parameters", {
                  params: {
                    object: object,
                    deselectedTicketType: deselectedTicketType
                  }
                });

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee10);
      }))();
    },
    onObjectClicked: function onObjectClicked(object) {
      // console.log("----- onObjectClicked");
      // console.log("object");
      // console.log(object);
      LogService.info("Seating Plan onObjectClicked triggered with attached data", {
        params: {
          object: object
        }
      });
    },
    onSelectionInvalid: function onSelectionInvalid(violations) {
      // console.log("----- onSelectionInvalid");
      // console.log("violations");
      // console.log(violations);
      LogService.info("Seating Plan onSelectionInvalid triggered with attached data", {
        params: {
          violations: violations
        }
      });
    },
    onSelectionValid: function onSelectionValid(arg) {// console.log("----- onSelectionValid");
      // console.log("arg");
      // console.log(arg);
    },
    buildPricingData: function buildPricingData(subCategories) {
      var _this7 = this;

      var pricingData = [];

      if (!subCategories || !subCategories.length) {
        return pricingData;
      }

      subCategories.forEach(function (pc) {
        var pd = {
          category: pc.seatsCat || pc.name,
          ticketTypes: []
        };
        pd.ticketTypes = pc.prices.map(function (p) {
          return {
            category: pc.name,
            categoryId: pc.id,
            currency: _this7.$props.product.currency,
            label: p.name,
            price: p.value / 100,
            priceCategory: String(p.id)
            /*null*/
            ,
            priceId: p.id,
            priceName: p.name,
            seatsCat: pc.seatsCat || pc.name,
            ticketType: String(p.id),
            priceOrder: !p.sortPrice && p.sortPrice !== 0 ? 25 : p.sortPrice
          };
        });
        pricingData.push(pd);
      }); // Now lets sort the pricingData based on priceOrder

      pricingData.forEach(function (pd) {
        pd.ticketTypes.sort(function (a, b) {
          return a.priceOrder - b.priceOrder;
        });
      });
      return pricingData;
    },
    generateSeatsIoHoldToken: function generateSeatsIoHoldToken() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var tokenObj, bookingUuid, bookingCopy;
        return regeneratorRuntime.wrap(function _callee12$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                console.log("hi from generateHoldToken");
                tokenObj = null;
                _context15.prev = 2;
                LogService.info("Generating holdToken");
                _context15.next = 6;
                return generateHoldToken();

              case 6:
                tokenObj = _context15.sent;
                console.log("tokenObj");
                console.log(tokenObj);
                bookingUuid = BookingModule.selectedBookingUUID; // Set a timeout to handle hold token expiration

                console.log("preparing to watch holdToken expiry");
                console.log("tokenObj.expiresInSeconds");
                console.log(tokenObj.expiresInSeconds);
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                  return regeneratorRuntime.wrap(function _callee11$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          LogService.info("Hold token has expired, informing the user that unconfirmed PSS are going to be removed");
                          _context14.next = 3;
                          return handleHoldTokenExpiration(bookingUuid);

                        case 3:
                        case "end":
                          return _context14.stop();
                      }
                    }
                  }, _callee11);
                })), tokenObj.expiresInSeconds * 1000);
                _context15.next = 21;
                break;

              case 16:
                _context15.prev = 16;
                _context15.t0 = _context15["catch"](2);
                console.log(_context15.t0);
                LogService.info("Error, failed to generate holdToken", _context15.t0, LogLevel.Error);
                NotificationService.showCustomError("Error, failed to generate holdToken");

              case 21:
                // now lets persist this holdToken in the selectedBooking object
                bookingCopy = cloneDeep(BookingModule.selectedBooking);
                bookingCopy.seatsIoHoldToken = tokenObj;
                BookingModule.updateBooking(bookingCopy);
                return _context15.abrupt("return", tokenObj.holdToken);

              case 25:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee12, null, [[2, 16]]);
      }))();
    }
  }
});